import styled from "styled-components";
import * as global from './../helpers/Helper'
import {IoSend} from 'react-icons/io5'

export const ContactContainer = styled.section`
  max-width: 1000px;
  width: 95%;
  margin: 0 auto;
  padding: 24px 0px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`
export const ContactGrid = styled.div`
  display: grid;
  gap: 12px;
  @media (min-width: 992px) {
    grid-template-areas: 
    "info form"
    "social form";
    .info {grid-area: info}
    .social {grid-area: social}
    .form {grid-area: form}
  }
  @media (min-width: 1200px) {
    grid-template-columns: auto 600px;
    gap: 24px;
  }
`
export const ContactInfo = styled.article`
  text-align: center;
  display: grid;
  gap: 12px;
  & h3 {
    font-size: 24px;
    line-height: 24px;
    color: ${global.ColorMain};
    @media (min-width: 992px) {
      font-size: 30px;
      line-height: 30px;
    }
  }
  & p {
    font-size: 18px;
    line-height: 24px;
    color: ${global.ColorWhite};
    @media (min-width: 992px) {
      font-size: 22px;
      line-height: 30px;
    }
  }
  @media (min-width: 992px) {
    margin-top: auto;
  }
`
export const ContactForm = styled.form`
  background-color: ${global.ColorMain};
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  border-radius: 50px;
  padding: 18px;
  display: grid;
  gap: 12px;
  @media (min-width: 576px) {
    grid-template-areas: 
    "name tel"
    "mail mail"
    "mes mes"
    "submit submit";
    .name {grid-area: name}
    .tel {grid-area: tel}
    .mail {grid-area: mail}
    .mes {grid-area: mes}
    .submit {grid-area: submit}
  }
`
export const ContactFormItem = styled.div`
  width: 100%;
  display: grid;
  gap: 12px;
  text-align: center;
  & label {
    color: ${global.ColorSec};
    font-family: ${global.FontSigmar};
    font-size: 24px;
    line-height: 24px;
    @media (min-width: 992px) {
      font-size: 30px;
      line-height: 30px;
    }
  }
  & input {
    border: none;
    height: 36px;
    font-size: 20px;
    padding: 0px 12px;
    font-family: myfont;
    color: ${global.ColorSec};
  }
  & textarea {
    border: none;
    resize: none;
    height: 108px;
    font-size: 20px;
    padding: 12px;
    font-family: myfont;
    color: ${global.ColorSec};
  }
`
export const Submit = styled.button`
  background-color: ${global.ColorSec};
  border: none;
  margin: 10px 0px;
  font-size: 24px;
  & span {
    font-family: ${global.FontSigmar};
    color: ${global.ColorWhite};
    display: inline-flex;
    align-items: center;
    gap: 12px;
  }
  @media (min-width: 992px) {
    cursor: pointer;
    font-size: 30px;
    position: relative;
    overflow: hidden;
    & span {
      position: relative;
      z-index: 10;
    }
    &::after {
      content: '';
      position: absolute;
      top: 0px;
      left: -100%;
      width: 100%;
      height: 100%;
      background-color: ${global.ColorRed};
      transition: .5s all;
    }
    &:hover::after {
      left: 0px;
      transition: .5s all;
    }
  }
  @media (min-width: 1200px) {
    width: 40%;
    margin-left: auto;
  }
`
export const Send = styled(IoSend)`
  font-size: 24px;
  color: ${global.ColorWhite};
`
export const ContactSocial = styled.article`
  display: grid;
  gap: 12px;
  & h3 {
    text-align: center;
    font-size: 24px;
    line-height: 24px;
    color: ${global.ColorMain};
    @media (min-width: 992px) {
      font-size: 30px;
      line-height: 30px;
    }
  }
  @media (min-width: 992px) {
    margin-bottom: auto;
  }
`
export const ContactMobile = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  & img {
    height: 40px;
    @media (min-width: 992px) {
      height: 50px;
    }
  }
`



